export default __webpack_public_path__ + "b8fe6d9f6c0e373211e8a81de43b232d.png";